/* ── VERON · Bilderkarussell in der Produktkachel ────────────────────────
   Vorbild H&M (Screenshots Fynn 24.09.2026): der Kunde wischt die Bilder
   schon in der Übersicht durch, mit zwei dünnen Chevrons an den Rändern.

   Das Wischen selbst macht der Browser — die Schiene ist ein Scroll-Kasten
   mit `scroll-snap-type: x mandatory`. Diese Datei löst nur vier Dinge:

     1. Klick auf einen Pfeil fährt eine Bildbreite weiter. Gefahren wird auf
        eine ABSOLUTE, auf ganze Bildbreiten gerundete Zielposition, nicht per
        `scrollBy`: bei zwei schnellen Klicks während der laufenden Animation
        summieren sich relative Sprünge sonst zu einer krummen Position, die
        der Snap anschließend irgendwohin zurückzieht.
        Der Klick wird in der EINFANG-Phase gestoppt, sonst öffnet der
        umschließende Kachel-Link das Produkt.

     2. Ein Wisch darf nicht als Klick auf den Kachel-Link zählen. Gemessen
        wird die Fingerstrecke zwischen Drücken und Loslassen — das ist die
        Absicht selbst und gilt für Finger wie Maus. Ein reiner Zeitabstand
        zum letzten Scroll-Ereignis reicht nicht: `scrollLeft` zu setzen feuert
        das Ereignis erst im nächsten Takt, und genau in dieser Lücke ging bei
        der Abnahme am 24.09.2026 ein Klick durch und öffnete das Produkt.

     3. Zusätzlich die Zeitsperre: fährt die Pfeil-Animation noch, wird ein
        Klick auf die Schiene ebenfalls verworfen. Die beiden Sperren decken
        sich gegenseitig die blinden Flecken ab.

     4. `is-scrolled` / `is-at-end` steuern, welcher Pfeil sichtbar ist.
        Bewusst so herum: OHNE JavaScript gilt „am Anfang", damit auch
        nachgeladene Kacheln (Filter, Paginierung) sofort richtig aussehen. */
(function () {
  'use strict';
  if (window.__veronCardRail) return;
  window.__veronCardRail = true;

  var SCHIENE = '[data-veron-rail]';
  var WISCH_PX = 10;     // ab hier gilt es als Wisch, nicht als Tippen
  var NACHLAUF_MS = 350; // so lange nach einer Bewegung bleibt der Klick gesperrt

  var zuletztBewegt = new WeakMap();
  var druckX = null, druckY = null, warWisch = false;

  function schieneVon(el) {
    var karte = el.closest('.veron-card');
    return karte ? karte.querySelector(SCHIENE) : null;
  }

  function sanft() {
    try {
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return true;
    }
  }

  function standSetzen(schiene) {
    var karte = schiene.closest('.veron-card');
    if (!karte) return;
    var rest = schiene.scrollWidth - schiene.clientWidth;
    karte.classList.toggle('is-scrolled', schiene.scrollLeft > 2);
    karte.classList.toggle('is-at-end', rest > 0 && schiene.scrollLeft >= rest - 2);
  }

  /* Absolute Zielposition: erst auf ganze Bildbreiten runden, dann einen
     Schritt gehen, dann in die gültigen Grenzen klemmen. */
  function ziel(schiene, richtung) {
    var breite = schiene.clientWidth;
    if (!breite) return schiene.scrollLeft;
    var jetzt = Math.round(schiene.scrollLeft / breite) * breite;
    var max = Math.max(0, schiene.scrollWidth - breite);
    return Math.max(0, Math.min(jetzt + breite * richtung, max));
  }

  /* 1. Pfeilklick — Einfangphase, damit der Kachel-Link nicht zuerst greift. */
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest && e.target.closest('[data-veron-rail-go]');
    if (!knopf) return;
    e.preventDefault();
    e.stopPropagation();
    var schiene = schieneVon(knopf);
    if (!schiene) return;
    var richtung = parseInt(knopf.getAttribute('data-veron-rail-go'), 10) || 1;
    schiene.scrollTo({ left: ziel(schiene, richtung), behavior: sanft() ? 'smooth' : 'auto' });
  }, true);

  /* 2. Fingerstrecke messen. */
  document.addEventListener('pointerdown', function (e) {
    if (!e.target.closest || !e.target.closest(SCHIENE)) {
      druckX = null;
      return;
    }
    druckX = e.clientX;
    druckY = e.clientY;
    warWisch = false;
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (druckX === null) return;
    if (Math.abs(e.clientX - druckX) > WISCH_PX || Math.abs(e.clientY - druckY) > WISCH_PX) {
      warWisch = true;
    }
  }, true);

  /* 3. Klick verwerfen, wenn gewischt wurde ODER gerade noch Bewegung war. */
  document.addEventListener('click', function (e) {
    var schiene = e.target.closest && e.target.closest(SCHIENE);
    if (!schiene) return;
    var t = zuletztBewegt.get(schiene);
    var frisch = t && Date.now() - t < NACHLAUF_MS;
    if (warWisch || frisch) {
      e.preventDefault();
      e.stopPropagation();
    }
    warWisch = false;
    druckX = null;
  }, true);

  /* 4. Bewegung merken, Pfeilstand nachführen.
     Bewusst OHNE requestAnimationFrame: der Stand hing sonst an einer laufenden
     Bildschleife. Bei der Abnahme am 24.09.2026 fiel auf, dass ein Browser ohne
     Zeichenschleife gar kein rAF ausführt — dann blieben die Pfeile für immer im
     Anfangszustand. `standSetzen` liest drei Werte und schaltet zwei Klassen;
     das darf direkt im Scroll-Griff passieren. Scroll-Ereignisse kommen ohnehin
     nur von der einen Schiene, die gerade bewegt wird. */
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el || el.nodeType !== 1 || !el.matches || !el.matches(SCHIENE)) return;
    zuletztBewegt.set(el, Date.now());
    standSetzen(el);
  }, true);
})();
